/// <reference path="../../global/fn.js" />

(function ($) {
    $.widget("nsp.news_grp", {
        options: {
            slickOptions:{
                arrows: false,
                autoplay: true,
                autoplaySpeed: 8000,
                infinite: false,
                slidesToShow: 1,
                slidesToScroll: 1,
                dots: true,
                rows: 0,
                pauseOnFocus: false, 
                pauseOnHover: false
            }
        },

        _create: function () {
            this.wrap = this.element;
            

            this.createAnimation()

            this.wrap.each((indx, el)=>{
                
                $(el).on('init', (slick)=>{
                    var dots = $('.slick-dots', $(slick.target))  
                    api.fn.slickDotsInit(dots, this.options.slickOptions.autoplaySpeed/1000)
                })
                .slick(this.options.slickOptions)
                .on('beforeChange', (event, slick, currentSlide, nextSlide)=>{
                    var dots = $('.slick-dots', $(event.target))
                    api.fn.slickDotsFilled(dots, nextSlide)
                })
            });

            
        },
      

        createAnimation: function(){
            this.wrap = this.element;

            var firstItem = jQuery('.s-news-grp__gal--feat').find('.s-news-grp__gal__item').eq(0).find('.b-news-wdgt--feat');
            var firstBox = jQuery('.s-news-grp__gal--feat').find('.s-news-grp__gal__item').eq(0).find('.s-news-grp__box');

            var bgColor = $("<span class='fillBg' style='position:absolute'></span>" );
           
            firstBox.append(bgColor)
            firstItem.css('background-color', 'transparent')
        }

    });
})(jQuery);
